import { datadogLogs } from '@datadog/browser-logs';
// import LogRocket from 'logrocket';
import { typecastError } from 'utils/error';
import { isLocalhost } from 'utils/is-localhost';
import { isNitroEnvironment } from 'utils/is-nitro-env';
import { addDatadogRumError } from 'vendor/datadog-rum/rum-loader';
const _log = (status)=>(message, context)=>{
        datadogLogs.logger.log(message, context, status);
        if (isLocalhost() || isNitroEnvironment()) {
            // eslint-disable-next-line no-console
            console[status](message, context);
        }
    };
const log = _log('info');
const info = _log('info');
const warn = _log('warn');
const debug = _log('debug');
const _error = _log('error');
const error = (message, { error: err, ...context })=>{
    const reason = typecastError(err);
    let emittedMessage = message;
    try {
        var _reason_message;
        // Last message wins (the giving-up → boundary chain relies on the
        // boundary's `__app_crash` marker landing on the instance so the RUM
        // copy and the console-forwarded copy carry it) — EXCEPT when the
        // rewrite would re-apply a prefix the message already carries: callers
        // build "prefix: <error.message>" and re-log on fallback re-renders,
        // which used to compound into "__app_crash: __app_crash: ..."
        // ungroupable strings. Applying a given prefix is idempotent now, and
        // the compounded caller string is normalized back to the stable form so
        // the Logs channel and RUM stay consistent.
        const currentMessage = (_reason_message = reason.message) !== null && _reason_message !== void 0 ? _reason_message : '';
        const derivedPrefix = message.endsWith(currentMessage) ? message.slice(0, message.length - currentMessage.length) : null;
        const isCompounding = derivedPrefix != null && derivedPrefix !== '' && currentMessage.startsWith(derivedPrefix);
        if (isCompounding) {
            emittedMessage = currentMessage;
        } else {
            reason.message = message;
        }
    } catch (unused) {
    // Some errors (DOMException, cross-realm/native, frozen instances) expose
    // `message` as a getter-only property — assigning throws
    // "Cannot set property message ... which has only a getter". Logging must
    // never crash the app (this runs from the ErrorBoundary fallback, so a
    // throw here turns a recoverable error into a boundary loop). Skip the
    // rename and let RUM keep the original message.
    }
    _error(emittedMessage, context);
    addDatadogRumError(reason, context);
// LogRocket.captureException(reason, {
//   extra: {
//     pageUrl: window.location.href,
//     info: JSON.stringify(context?.info),
//   },
// });
};
// Once-per-page-load emission keyed by the caller's dedup key — for terminal
// signals that a render/retry loop could otherwise re-emit indefinitely.
// Keys are namespaced by level so an error and a warn sharing a natural key
// never suppress each other.
const onceKeys = new Set();
const once = (level, fn)=>(dedupKey, ...args)=>{
        const key = `${level}:${dedupKey}`;
        if (onceKeys.has(key)) {
            return;
        }
        onceKeys.add(key);
        fn(...args);
    };
export const logger = {
    log,
    info,
    warn,
    debug,
    error,
    errorOnce: once('error', error),
    warnOnce: once('warn', warn)
};
